export default __webpack_public_path__ + "static/media/services-small.b13bc140.jpg";